export default __webpack_public_path__ + "static/media/bannercfdi.5d13c159.jpg";